import Vue from 'vue';
import App from './App.vue';
import router from './routing/router';
import store from './vuex/store';
// import './helpers/registerServiceWorker';
import VueAwesomeSwiper from 'vue-awesome-swiper';

// Main Sass file
import './assets/sass/main.scss';

// Font awesome icons
import 'font-awesome/scss/font-awesome.scss';

// Vue-Awesome-Swiper css
import 'swiper/dist/css/swiper.css';

// animate.css : A cross-browser library of CSS animations. As easy to use as an easy thing.
import 'animate.css/animate.min.css';

// Import Axios for all network requests
import axios from 'axios';

// Import Sentry for error logging framework
import Raven from 'raven-js';
import RavenVue from 'raven-js/plugins/vue';

import Buefy from 'buefy';

import { Photo } from '@/models/photo';

// CURRENT VERSION NUMBER (18004 -> 18 year, 004 day of the year)
Vue.prototype.$version = '1.0.2.18346';

Vue.use(Buefy);

// define vue-awesome-swiper globally
Vue.use(VueAwesomeSwiper /* { default global options } */);

Vue.config.productionTip = false;

// Fetch the token
const token = localStorage.getItem('api_token');

// If the token exist, set it in the authorization
if (token) {
    // Axios configuration
    axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
    axios.defaults.headers.common.Authorization = 'Bearer '.concat(token);
}

// Define the base api url
axios.defaults.baseURL = process.env.VUE_APP_API_URL;

// Create a Global CONST Variable , Accessable to all Vue instance
Vue.mixin({
    data() {
        return {
            get VUE_APP_BACKEND_URL() {
                return  process.env.VUE_APP_BACKEND_URL;
            },

            get API_BASE_URL() {
                return process.env.API_BASE_URL;
            },

            getImagePath(photo: Photo) {
                return  process.env.VUE_APP_BACKEND_URL + photo.path;
            },

            getImageThumbPath(photo: Photo) {
                return  process.env.VUE_APP_BACKEND_URL + photo.path + '.thumbnail-min.jpg';
            },
        };
    },
});

// Sentry error logging framework
Raven
    .config('https://b811f5091641454786389978dc5cacbe@sentry.io/307035', {
        shouldSendCallback: () => {

            // Only send sentry callback when sentry is enabled in the env file
            if (process.env.VUE_APP_SENTRY_ENABLED !== undefined) {
                return (process.env.VUE_APP_SENTRY_ENABLED!.trim() === 'true');
            }

            return false;
        },
    })
    .addPlugin(RavenVue, Vue)
    .install();

new Vue({
    router,
    store,
    render: (h) => h(App),
}).$mount('#app');
